<template>
    <eg-modalv2
        height="auto"
        :show="showModal"
        :paddingBody="true"
        :showFooter="false"
        :showHeader="true"
        :rounded="true"
        :scrollable="false"
        @close="$emit('closeModal')"
    >
        <div slot="header">Notificações</div>
        <div slot="body" class="modal-body">
            <div v-if="notifications.results.length">
                <div
                    v-for="notification in notifications.results"
                    :key="notification.id"
                    class="notification"
                    :class="notification.unread ? 'unread' : 'read'"
                >
                    <i class="fas fa-exclamation-circle icon"></i>
                    <div class="content">
                        <span>{{ notification.title }}</span>
                        <span class="data">{{ dateFilter(notification.createdAt) }}</span>
                    </div>
                </div>
                <div v-if="this.notifications.next" @click="nextPage" class="next-link">Ver Mais</div>
            </div>
            <div v-else>
                <p>Você não poussui notificações</p>
            </div>
        </div>
    </eg-modalv2>
</template>

<script>
import { dateFilter } from '@/utils/filters';
export default {
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        notifications: {
            type: [Array, Object]
        },
        isMobile: Boolean
    },
    data() {
        return {
            show: this.showModal,
            next: 1
        };
    },
    emits: ['nextPage'],
    methods: {
        dateFilter,
        nextPage() {
            this.next = this.next + 1
            this.$emit('nextPage', this.next)
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-body {
    height: 300px;
    overflow-y: scroll;
    text-align: center;
    .notification {
        display: flex;
        align-content: center;
        justify-content: start;
        gap: 20px;
        padding: 26px 10px;
        border-bottom: 1px solid rgba(165, 165, 165, 0.25);
        .icon {
            color: red;
            font-size: 22px;
            line-height: 20px;
        }
        .content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
        }
    }
    .unread {
        background-color: #fff;
        font-weight: bold;
        &:hover {
            background-color: #f9f9f9;
            cursor: pointer
        }
    }
    .read {
        background-color: #f5f5f5;
        .icon {
            color: #a5a5a5
        }
    }
}

.next-link {
    cursor: pointer;
    margin-top: 10px;
    color: #009fe3;
}

.modal-body::-webkit-scrollbar {
    width: 10px; /* width of the entire scrollbar */
}

.modal-body::-webkit-scrollbar-track {
    background: #fff; /* color of the tracking area */
}

.modal-body::-webkit-scrollbar-thumb {
    background-color: #dbdbdb; /* color of the scroll thumb */
    border-radius: 10px; /* roundness of the scroll thumb */
    border: 2px solid #fff; /* creates padding around scroll thumb */
}

::v-deep .modal-container {
    border-radius: 0px 0px 7px 7px;
}

.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}
::v-deep .multiselect__content-wrapper {
    min-width: fit-content;
    box-shadow: 0px 3px 6px #00000029;
    overflow-y: visible;
}
@media screen and (max-width: 768px) {
    ::v-deep .modal-body.padding-body {
        padding: 1rem;
    }
    .content {
        flex-direction: column-reverse;
        align-items: flex-start !important;
        text-align: left;
        .data {
            font-size: 12px;
            margin-bottom: 8px;
        }
    }
}
</style>
